import { render, staticRenderFns } from "./GameInfo.vue?vue&type=template&id=41e3ed66&scoped=true&"
import script from "./GameInfo.vue?vue&type=script&lang=js&"
export * from "./GameInfo.vue?vue&type=script&lang=js&"
import style0 from "@/styles/GameInfo.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./GameInfo.vue?vue&type=style&index=1&id=41e3ed66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e3ed66",
  null
  
)

export default component.exports